import { render, staticRenderFns } from "./OrderCreateForm.vue?vue&type=template&id=6900e562&"
import script from "./OrderCreateForm.vue?vue&type=script&lang=js&"
export * from "./OrderCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports